import React from 'react'

const MprolabIcon: React.FC = () => {
  return (
    <svg width="154" height="26" viewBox="0 0 154 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_95_27444)">
        <path
          d="M71.3571 11.1654V20.0076H67.6536V11.4217C67.6536 9.72585 66.7907 8.69212 65.2401 8.69212C63.6041 8.69212 62.5704 9.78138 62.5704 11.9385V20.0076H58.8669V11.4217C58.8669 9.72585 58.004 8.69212 56.4534 8.69212C54.9028 8.69212 53.7538 9.78138 53.7538 11.9385V20.0076H50.0503V5.65074H53.7538V7.17143C54.5568 5.96684 55.9067 5.24921 57.7435 5.24921C59.5802 5.24921 60.8446 5.99674 61.6477 7.31667C62.5362 6.02664 63.9715 5.24921 65.9236 5.24921C69.1956 5.24921 71.3485 7.57296 71.3485 11.1654H71.3571Z"
          fill="white"
        />
        <path
          d="M88.8109 12.8313C88.8109 17.1072 85.6542 20.4091 81.8055 20.4091C79.7081 20.4091 78.1874 19.636 77.1537 18.3118V25.7487H73.4502V5.65074H77.1537V7.34657C78.1874 6.02664 79.7081 5.24921 81.8055 5.24921C85.6542 5.24921 88.8109 8.55116 88.8109 12.827V12.8313ZM85.1074 12.8313C85.1074 10.4179 83.4116 8.78183 81.1177 8.78183C78.8239 8.78183 77.1537 10.4179 77.1537 12.8313C77.1537 15.2448 78.8495 16.8808 81.1177 16.8808C83.386 16.8808 85.1074 15.2448 85.1074 12.8313Z"
          fill="white"
        />
        <path
          d="M98.4309 5.3645V9.49942C96.5087 9.26875 94.0653 10.1316 94.0653 13.1474V20.0076H90.3618V5.6507H94.0653V8.11969C94.8128 6.16756 96.6197 5.3645 98.4309 5.3645Z"
          fill="white"
        />
        <path
          d="M98.23 12.8313C98.23 8.55116 101.587 5.25348 105.808 5.25348C110.028 5.25348 113.416 8.55543 113.416 12.8313C113.416 17.1072 110.028 20.4091 105.808 20.4091C101.587 20.4091 98.23 17.1072 98.23 12.8313ZM109.712 12.8313C109.712 10.5076 108.016 8.86726 105.808 8.86726C103.599 8.86726 101.933 10.5033 101.933 12.8313C101.933 15.1593 103.629 16.7954 105.808 16.7954C107.986 16.7954 109.712 15.1593 109.712 12.8313Z"
          fill="white"
        />
        <path d="M117.004 0.251404H118.32V19.8495H117.004V0.251404Z" fill="white" />
        <path
          d="M135.662 5.71907V19.8453H134.402V16.4152C133.356 18.6962 131.267 20.14 128.584 20.14C124.59 20.14 121.668 16.9748 121.668 12.7672C121.668 8.55969 124.616 5.50122 128.584 5.50122C131.267 5.50122 133.356 6.89376 134.402 9.14917V5.71907H135.662ZM134.376 12.7715C134.376 9.15345 132.044 6.6332 128.695 6.6332C125.346 6.6332 123.01 9.28587 123.01 12.7715C123.01 16.2571 125.423 18.9397 128.695 18.9397C131.967 18.9397 134.376 16.3938 134.376 12.7715Z"
          fill="white"
        />
        <path
          d="M154 12.7715C154 16.979 151.053 20.1443 147.059 20.1443C144.406 20.1443 142.313 18.7218 141.241 16.4451V19.8495H140.006V0.251404H141.322V8.93558C142.42 6.79123 144.487 5.44995 147.084 5.44995C151.053 5.44995 154 8.58531 154 12.7672V12.7715ZM152.663 12.7715C152.663 9.28585 150.224 6.63319 146.978 6.63319C143.731 6.63319 141.296 9.15343 141.296 12.7715C141.296 16.3895 143.629 18.9397 146.978 18.9397C150.327 18.9397 152.663 16.3126 152.663 12.7715Z"
          fill="white"
        />
        <path
          d="M37.667 8.20513V17.7778L30.9008 24.544H21.3281L11.6572 14.8688L13.5154 13.0107L22.4174 21.9213H29.8201L35.0528 16.6885V9.28585L27.2144 1.45599H30.9179L37.6628 8.20513H37.667ZM16.3603 1.45599H6.74914L0 8.20513V17.7778L6.76623 24.544H10.4697L2.6185 16.6885V9.28585L7.85121 4.05313H15.2539L24.1688 12.968L26.0226 11.1141L16.3603 1.45599ZM23.6946 1.45599H20.0509L29.9824 11.3875V14.5912L27.7185 16.8551H24.5148L14.2245 6.54775H8.88922L5.11739 10.3196V15.6548L14.0023 24.5398H17.646L7.69317 14.5869V11.3832L9.95712 9.11926H13.1608L23.4511 19.4266H28.7864L32.5582 15.6548V10.3196L23.6946 1.45599Z"
          fill="url(#paint0_linear_95_27444)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_95_27444"
          x1="3.13963"
          y1="22.8012"
          x2="34.5317"
          y2="3.18599"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF029A" />
          <stop offset="0.12" stopColor="#E310B3" />
          <stop offset="0.49" stopColor="#9239FF" />
          <stop offset="0.56" stopColor="#7E53FF" />
          <stop offset="0.77" stopColor="#3CA9FF" />
          <stop offset="0.93" stopColor="#12DFFF" />
          <stop offset="1" stopColor="#03F5FF" />
        </linearGradient>
        <clipPath id="clip0_95_27444">
          <rect width="154" height="25.4972" fill="white" transform="translate(0 0.251404)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default MprolabIcon
